if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      this.autoplayDelay = 3500;
      this._timer = null;

      if (this.length <= 1) {
        this._setDisabledState();
        return;
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this._stopAutoplay();
          this.changeSlide('next');
          this._startAutoplay();
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this._stopAutoplay();
          this.changeSlide('prev');
          this._startAutoplay();
        });
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._stopAutoplay();
        else this._startAutoplay();
      });

      this._setDisabledState();
      this._startAutoplay();
    }

    _startAutoplay() {
      this._stopAutoplay();
      this._timer = setInterval(() => {
        this.changeSlide('next', { wrap: true });
      }, this.autoplayDelay);
    }

    _stopAutoplay() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    _setDisabledState() {
      const atStart = this.index === 0;
      const atEnd = this.index === this.length - 1;

      if (this.nextButton) {
        this.nextButton.classList.toggle('announcement-bar__content-nav--disabled', atEnd);
      }
      if (this.prevButton) {
        this.prevButton.classList.toggle('announcement-bar__content-nav--disabled', atStart);
      }
    }

    changeSlide(direction, { wrap = false } = {}) {
      if (!this.length) return;

      let newIndex = this.index;

      if (direction === 'next') {
        newIndex = this.index + 1;
        if (newIndex > this.length - 1) {
          newIndex = wrap ? 0 : this.length - 1;
        }
      } else if (direction === 'prev') {
        newIndex = this.index - 1;
        if (newIndex < 0) {
          newIndex = wrap ? this.length - 1 : 0;
        }
      }

      if (newIndex === this.index) return;

      this.index = newIndex;

      this._setDisabledState();

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}
